import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Map, OrderedMap, Set } from 'immutable';

import User from 'models/user';
import Brand from 'models/brand';
import Search from 'models/search';
import { Location } from 'models/locations';

import * as AppContext from 'lib/app-context';
import {
  CLOSE_BUTTON_IMPRESSION,
  CLOSE_BUTTON_CLICK,
  CONTACT_US_BUTTON_CLICK,
  MONTHLY_SEARCH_MODAL_IMPRESSION,
} from 'lib/analytics/events';

import Prompt, { PROMPT_STEP } from 'components/search/monthly-form/prompt';
import Contact, { CONTACT_STEP } from 'components/search/monthly-form/contact';
import ThankYou, { THANK_YOU_STEP } from 'components/search/monthly-form/thank-you';

const propTypes = {
  currentSearch: PropTypes.instanceOf(Search).isRequired,
  selectedLocation: PropTypes.instanceOf(Location),
  brand: PropTypes.instanceOf(Brand).isRequired,
  user: PropTypes.instanceOf(User).isRequired,
  optOut: PropTypes.bool.isRequired,
  appContext: PropTypes.string.isRequired,
  requiredFields: PropTypes.instanceOf(Set),
  requiredFieldErrors: PropTypes.oneOfType([
    PropTypes.instanceOf(Map),
    PropTypes.instanceOf(OrderedMap),
  ]),
  monthlyFormSuccess: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  modifyRequiredFieldList: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedLocation: null,
  monthlyFormSuccess: false,
  requiredFields: Set(),
  requiredFieldErrors: Map(),
};
class MonthlyForm extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.monthlyFormSuccess) {
      return {
        ...prevState,
        step: THANK_YOU_STEP,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    const user = this.props.user;
    const { name, email, phone } = user;

    this.state = {
      name,
      email,
      phone,
      contact: false,
      step: PROMPT_STEP,
    };

    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.contact = this.contact.bind(this);
    this.trackEvent = this.trackEvent.bind(this);
  }

  componentDidMount() {
    if (this.shouldRender) {
      this.trackEvent(MONTHLY_SEARCH_MODAL_IMPRESSION);
      this.trackEvent(CLOSE_BUTTON_IMPRESSION);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.shouldRender && prevState.step !== this.state.step) {
      this.trackEvent(MONTHLY_SEARCH_MODAL_IMPRESSION);
      this.trackEvent(CLOSE_BUTTON_IMPRESSION);
    }
  }

  onClose() {
    this.trackEvent(CLOSE_BUTTON_CLICK);
    this.props.onClose();
  }

  onSubmit({ email, name, phone }) {
    this.props.onSubmit({
      data: { email, name, phone_number: phone },
      monthlyPhoneNumber: this.props.currentSearch.brandedMonthlyPhoneNumber(this.props.brand),
    });
  }

  contact(e) {
    e.preventDefault();
    this.trackEvent(CONTACT_US_BUTTON_CLICK);
    this.setState({ step: CONTACT_STEP });
  }

  trackEvent(event) {
    const trackedEvent = event;
    const { step } = this.state;
    trackedEvent.properties = {
      ...(event.properties || {}),
      ModalScreen: step,
    };
    this.props.trackEvent(trackedEvent);
  }

  get shouldRender() {
    const { currentSearch, selectedLocation, optOut, brand, appContext } = this.props;

    return (
      currentSearch.isMonthlySearch &&
      currentSearch.brandedMonthlyPhoneNumber(brand) &&
      !selectedLocation &&
      !optOut &&
      appContext === AppContext.DESKTOP
    );
  }

  render() {
    if (!this.shouldRender) { return null; }
    const { currentSearch, brand } = this.props;
    const { step } = this.state;
    const { trackEvent } = this;
    const contactPhone = currentSearch.brandedMonthlyPhoneNumber(brand);

    return (
      <Fragment>
        <div className="hidden-sm hidden-xs">
          <div className="monthly-form position-absolute margin-horizontal-40 container-fluid padding-10 heavy-shadowed">
            <div className="row text-align-right">
              <div
                type="button"
                className="col-xs-12 float-right iconified-font iconified-x text-size-14 text-color-blue text-color-hover-blue clickable"
                onClick={this.onClose}
              />
            </div>
            <Prompt contact={this.contact} step={step} trackEvent={trackEvent} />
            <Contact
              onClose={this.onClose}
              contactPhone={contactPhone}
              onSubmit={this.onSubmit}
              step={step}
              trackEvent={trackEvent}
              user={this.props.user}
              requiredFields={this.props.requiredFields}
              requiredFieldErrors={this.props.requiredFieldErrors}
              modifyRequiredFieldList={this.props.modifyRequiredFieldList}
            />
            <ThankYou step={step} />
          </div>
        </div>
      </Fragment>
    );
  }
}

MonthlyForm.propTypes = propTypes;
MonthlyForm.defaultProps = defaultProps;
export default MonthlyForm;
